import MaterialIcon from '@/components/atom/MaterialIcon';
import { NonF2fDoctor } from '@/models/doctor/telemedicine';
import theme from '@/styles/theme';
import { cn } from '@/utils/style';

interface Props {
  doctor: NonF2fDoctor;
  cheapestPrice?: number;
}
const NonF2fDoctorItem = (props: Props) => {
  const { doctor } = props;
  return (
    <div className={'relative flex items-center justify-between pr-[16px] pl-[24px]'}>
      <div className={'flex w-full flex-col gap-[12px] pt-[20px] pb-[24px]'}>
        <div className={'flex flex-col gap-[2px]'}>
          <h2 className={'typography-ui-13r text-gray-400'}>{doctor.hospitalName}</h2>
          <div className={'flex items-center gap-[8px]'}>
            <h3 className={'typography-ui-19sb text-gray-900'}>{doctor.doctorNameFullText}</h3>
            <div className={'flex items-center'}>
              <MaterialIcon name={'star'} color={theme.color.yellow500} size={16} filled />
              <span className={'typography-ui-13m text-gray-700'}>{doctor.review.reviewAverageText}</span>
              <span className={'typography-ui-13r text-gray-400'}>({doctor.review.reviewCountText})</span>
            </div>
          </div>
          {doctor.bookingInfo.isBookingAvailable ? (
            <div className={'flex items-center gap-[5px]'}>
              {doctor.bookingInfo.closestSchedule && (
                <>
                  <p
                    className={cn([
                      'typography-ui-13m',
                      {
                        'text-green-700': doctor.bookingInfo.closestSchedule.isTodayBookable,
                        'text-primary-600': !doctor.bookingInfo.closestSchedule.isTodayBookable,
                      },
                    ])}
                  >
                    {doctor.bookingInfo.closestSchedule.scheduleTypeText}
                  </p>
                  <div className={'h-[10px] w-[1px] bg-gray-50'} />
                  <span className={'typography-ui-13r text-gray-400'}>
                    {doctor.bookingInfo.closestSchedule.schedule}
                  </span>
                </>
              )}
            </div>
          ) : (
            <p className={'typography-ui-13m text-gray-700'}>예약 마감</p>
          )}
        </div>
        {(doctor.professionalDepartmentName || doctor.readyForVideoCall) && (
          <div className={'flex items-center gap-[4px]'}>
            {doctor.professionalDepartmentName && (
              <h4
                className={'ty typography-ui-12m flex h-[20px] items-center rounded bg-gray-30 px-[4px] text-gray-500'}
              >
                {doctor.professionalDepartmentName} 전문의
              </h4>
            )}
            {doctor.readyForVideoCall && (
              <span
                className={'ty typography-ui-12m flex h-[20px] items-center rounded bg-gray-30 px-[4px] text-gray-500'}
              >
                영상진료
              </span>
            )}
          </div>
        )}
        {doctor.medicinePricing && (
          <p className={'typography-ui-20sb text-gray-900'}>{doctor.medicinePricing.medicinePriceDisplayPrice}원</p>
        )}
      </div>
      <div className={'relative pb-[8px]'}>
        {doctor.profileUrl && (
          <>
            <img
              className={'aspect-square h-[120px] w-[120px]'}
              src={doctor.profileUrl}
              alt={`${doctor.doctorName} 의사 사진`}
            />
            <div
              className={cn([
                'absolute right-0 bottom-[8px] left-0 h-[24px] w-[120px]',
                {
                  'bg-gradient-to-t from-white to-transparent': doctor.profileUrl,
                },
              ])}
            />
          </>
        )}
      </div>
      {!doctor.bookingInfo.isBookingAvailable && (
        <div className={'absolute top-0 right-0 bottom-0 left-0 bg-white opacity-50'} />
      )}
    </div>
  );
};

export default NonF2fDoctorItem;
